module.exports = __webpack_public_path__ + "img/no-invoice.aa539ea2.png";